export default {
  title: "Código Telefónico"
  , form: {
    lada: {
      label: "Código Area"
      , th: "Código Area"
    }
  }
  , errors: {
    BD6004: { text: "Ocurrió un error en el catálogo de Código Telefónico" }
    , WS6004: { text: "Ocurrió un error en el catálogo de Código Telefónico" }
    , JS6004: { text: "Ocurrió un error en el catálogo de Código Telefónico" }
    , C56004: { text: "Ocurrió un error en el catálogo de Código Telefónico" }
    , UK_Lada: { text: "Ya existe un registro con el mismo código" }
  }
}


// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/geograficos/lada.js